import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { Box } from '@mui/material';

// Pages
import HomePage from './pages/HomePage/HomePage';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import DashboardPage from './pages/DashboardPage/DashboardPage';
import LoginPage from './pages/LoginPage/LoginPage';
import SignupPage from './pages/SignupPage/SignupPage';
import ExperiencesPage from './pages/ExperiencesPage/ExperiencesPage';
import ExperienceDetailPage from './pages/ExperienceDetailPage/ExperienceDetailPage';
import ExperienceBookingDetails from './components/ExperienceBookingDetails/ExperienceBookingDetails';
import ExperienceBookingConfirmation from './components/ExperienceBookingConfirmation/ExperienceBookingConfirmation';
import MyBookingsPage from './pages/MyBookingsPage/MyBookingsPage';

// Contexts
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            
            {/* Experience browsing (public but shows affiliate prices when logged in) */}
            <Route path="/experiences" element={<ExperiencesPage />} />
            <Route path="/experience/:id" element={<ExperienceDetailPage />} />
            
            {/* Booking page - requires approval */}
            <Route path="/experience-booking" element={<ProtectedRoute requireApproved={true}><ExperienceBookingDetails /></ProtectedRoute>} />
            <Route path="/experience-booking-confirmation/:orderId" element={<ProtectedRoute requireApproved={true}><ExperienceBookingConfirmation /></ProtectedRoute>} />
            <Route path="/my-bookings" element={<ProtectedRoute requireApproved={true}><MyBookingsPage /></ProtectedRoute>} />
            
            {/* Protected routes - require authentication */}
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute requireApproved={true}><DashboardPage /></ProtectedRoute>} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
